if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

			if ( parseInt(qty.value) - 1 < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qty.addEventListener('change', (e)=>{
				const currentQty = parseInt(qty.value);
				if ( parseInt(qty.value) - 1 < qtyMin ) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}
				if ( parseInt(qty.value) + 1 > qtyMax ) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}

				// Spejl værdien til andre selectors for samme variant (fx sticky-baren),
				// så synligt antal og det antal formen submitter altid stemmer overens.
				// Programmatisk .value udløser ikke 'change', så ingen løkke-risiko.
				const variantId = qty.getAttribute('data-variant-id');
				if ( variantId ) {
					document.querySelectorAll('.qty-selector[data-variant-id="' + variantId + '"]').forEach(el=>{
						if ( el !== qty ) el.value = qty.value;
					});
				}

			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
                    const newQty = currentQty - 1;
                  
					if ( newQty >= qtyMin ) {
                        const variantId = qty.getAttribute('data-variant-id');
                        const qtySelectors = document.querySelectorAll('.qty-selector[data-variant-id="' + variantId + '"]');

                        if (variantId != '' && qtySelectors.length > 0) {
                          for (let i = 0; i < qtySelectors.length; i++) {
                            qtySelectors[i].value = newQty;
                          }
                        } else {
                          qty.value = newQty;
                        }
						qtyPlus.classList.remove('disabled');
					} 
					if ( currentQty - 1 <= qtyMin ) {
						qtyMinus.classList.add('disabled');
					}
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
                    const newQty = currentQty + 1;
                  
					if ( newQty <= qtyMax ) {
                        const variantId = qty.getAttribute('data-variant-id');
                        const qtySelectors = document.querySelectorAll('.qty-selector[data-variant-id="' + variantId + '"]');

                        if (variantId != '' && qtySelectors.length > 0) {
                          for (let i = 0; i < qtySelectors.length; i++) {
                            qtySelectors[i].value = newQty;
                          }
                        } else {
                          qty.value = newQty;
                        }
						qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + 1 >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}
				}
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}